export const acceptanceArtifactUploadValidation = {
  artifactId: {
    type: 'array' as const,
    required: { value: true, message: 'File is required' },
    minSize: { value: 1, message: 'File is required' },
  },
  label: { type: 'string' as const, required: false },
};

export const editArtifactValidation = {
  artifactId: { type: 'array' as const, required: false },
  label: { type: 'string' as const, required: false },
};
